import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../shared/services/auth.service';
import { SidenavService } from '../../shared/services/sidenav.service';
import { AuthGuard } from '../../shared/services/auth.guard';
import { ScrollControlService } from '../../shared/services/scroll-control.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-backoffice',
  templateUrl: './backoffice.component.html',
  styleUrls: ['./backoffice.component.css']
})
export class BackofficeComponent implements OnInit {

  isOpen: boolean = false;
  userName: any;
  shouldPinSidenav: boolean = false;

  paramId: string | null = null;



  constructor(private service: AuthGuard,
    public authService: AuthService,
    private sidenavService: SidenavService,
    private scrollService: ScrollControlService,
    private route: ActivatedRoute) { }


  ngOnInit(): void {
    this.scrollService.setScroll(true);

    this.route.queryParams.subscribe(params => {
      this.paramId = params['id'];
    });

  }

  onSidenavToggle() {
    this.isOpen = !this.isOpen;
    this.sidenavService.sideNavState$.next(this.isOpen);
  }

  onCheckboxChange(event: any) {
    this.shouldPinSidenav = event;
    this.sidenavService.shouldPinSidenavState.next(this.shouldPinSidenav);
  }


}
